var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_447_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3372 14.0338C34.353 14.2724 34.353 14.5121 34.353 14.753C34.353 22.1115 28.7508 30.5963 18.5097 30.5963V30.5918C15.4846 30.5963 12.5218 29.7301 9.9751 28.096C10.415 28.1492 10.8572 28.1752 11.3005 28.1763C13.8087 28.1786 16.2446 27.3372 18.2157 25.7879C15.8329 25.7427 13.7431 24.1889 13.0137 21.9204C13.8483 22.081 14.7077 22.0482 15.5276 21.8254C12.9289 21.3007 11.0607 19.0175 11.0607 16.3667C11.0607 16.343 11.0607 16.3192 11.0607 16.2966C11.8354 16.7286 12.7016 16.9672 13.5882 16.9932C11.141 15.3591 10.3856 12.1045 11.8636 9.56009C14.6908 13.0386 18.8625 15.1533 23.3396 15.3784C22.8906 13.4446 23.5047 11.4181 24.9499 10.0577C27.1924 7.94861 30.7196 8.05717 32.8286 10.2997C34.076 10.0543 35.2713 9.59627 36.3648 8.94829C35.9487 10.2375 35.079 11.3321 33.9165 12.0288C35.0214 11.8964 36.0991 11.6013 37.1157 11.1512C36.3682 12.2696 35.4273 13.2456 34.3372 14.0338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_447_442",
    x: 0.975098,
    y: 0.544189,
    width: 45.1406,
    height: 40.0522,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_447_442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_447_442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.4bee617537fca090e986b74a81f48045.svg";
export { ForwardRef as ReactComponent };